import { render, staticRenderFns } from "./HealthReviewCard.vue?vue&type=template&id=01050af6"
import script from "./HealthReviewCard.vue?vue&type=script&lang=js"
export * from "./HealthReviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports